<div id="library-activities" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Library Activities</h2>
    <p class="inner-lead mt-3">
      The Library of Shah Satnam Ji Girls' College, Sirsa actively organises various programmes and activities to
      promote a reading culture and enhance students' research skills.
    </p>
    <hr class="divider">
    <h4 class="section-subtitle">Recent Activities</h4>
    <ul class="inner-lead">
      <li>National Library Week Celebration</li>
      <li>World Book Day Observation</li>
      <li>Book Exhibition and Display</li>
      <li>Essay and Slogan Writing Competitions</li>
      <li>Quiz on Library and Information Science</li>
      <li>Orientation Session for New Students</li>
      <li>N-LIST (National Library and Information Services Infrastructure) Resource Training</li>
    </ul>
    <hr class="divider">
    <!-- NOTE: Upload library activities image/PDF to: src/assets/pdf/library/library-activities.pdf -->
    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/library/library-activities.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;"></pdf-viewer>
    </div>
  </div>
</div>